if (!customElements.get("add-cart-button")) {
  class AddCartButton extends HTMLElement {
    // 标记
    _marks = {
      loading: "loading",
    };

    _shopify_features_script = document.querySelector(
      "script[id='shopify-features']"
    );
    _shopify_features_json = JSON.parse(
      this._shopify_features_script.innerHTML
    );
    _checkout_headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Basic " + btoa(this._shopify_features_json.accessToken),
    };

    get _variantId() {
      return this.getAttribute("data-variant-id");
    }
    get _quantity() {
      return this.getAttribute("data-quantity") ?? 1;
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.updateQuantity();
      this.elements = {
        loadingSpinner: this.querySelector(".loading__spinner"),
      };
      this.addEventListener("click", (e) => {
        this.startLoading();
        this.addToCart().finally(() => {
          this.finishLoading();
        });
      });
    }

    updateQuantity() {
      const mainQtyElement = document.querySelector('.product-form__main_quantity');

      if (mainQtyElement) {
        const quantityInput = mainQtyElement.querySelector('quantity-input input[name="quantity"]');

        if (quantityInput) {
          const updateDataQuantity = () => {
            const inputValue = quantityInput.value;
            let quantityArray = this.getAttribute('data-quantity').split(',');
            quantityArray[0] = inputValue;
            this.setAttribute('data-quantity', quantityArray.join(','));
          };

          quantityInput.addEventListener('change', updateDataQuantity);

          // 初始化时也更新 data-quantity 的第一位数值
          updateDataQuantity();
        }
      }
    }

    onCartUpdate() {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const targetElement = document.querySelector("cart-drawer");
          const sourceElement = html.querySelector("cart-drawer");
          targetElement.innerHTML = sourceElement.innerHTML;
          targetElement.classList.add("active");
          targetElement.classList.remove("is-empty");
          document.querySelector("body").classList.add("overflow-hidden");
        })
        .catch((e) => {
          console.error(e);
        });

      fetch(`${routes.cart_url}.js`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((cartData) => {
          const cartItemCount = cartData.item_count;

          const cartCountBubbles = document.querySelectorAll('#cart-icon-bubble .cart-count-bubble');
          if (cartCountBubbles.length === 0) {
            const cartIcons = document.querySelectorAll('#cart-icon-bubble');
            cartIcons.forEach((cartIcon) => {
              const newBubble = document.createElement('div');
              newBubble.className = 'cart-count-bubble';
              newBubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
              cartIcon.appendChild(newBubble);
            });
          } else {
            cartCountBubbles.forEach((bubble) => {
              bubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
            });
          }
        })
        .catch((error) => {
          console.error('There has been a problem with your fetch operation:', error);
        });
    }

    /**
     * 加购
     */
    async addToCart() {
      this.updateQuantity();
      const variantIds = this._variantId.split(",");
      const quantities = this._quantity.split(",");

      const defaultQuantity = quantities[0] || 1; // 默认数量为1，如果 quantities 为空
      if (variantIds.length !== quantities.length) {
        console.warn("变体ID与数量的数量不匹配，将使用相同的数量值。");
        quantities.length = variantIds.length; // 将数量数组的长度调整为与变体ID数组相同
        quantities.fill(defaultQuantity); // 用默认数量填充整个数组
      }


      const items = variantIds.map((id, index) => {
        return {
          form_type: "product",
          utf8: "✓",
          id: parseInt(id, 10),
          quantity: parseInt(quantities[index], 10), // 使用对应的数量值
        };
      });

      let data_json = {
        items: items,
      };

      let data = JSON.stringify(data_json);
      return fetch("/cart/add.json", {
        method: "POST",
        headers: this._checkout_headers,
        body: data,
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status === 422) {
              alert("Inventory shortage!");
            }
            throw new Error("请求失败");
          }
        })
        .then((response) => {
          return this.updateCart(response);
        })
        .catch((err) => {
          console.error(err);
        });
    }

    /**
     * 更新购物车，并弹出侧边购物车
     * @returns
     */
    async updateCart(response) {
      this.onCartUpdate();
    }

    startLoading() {
      this.setAttribute("aria-disabled", true);
      this.classList.add(this._marks.loading);
      this.elements.loadingSpinner?.classList.remove("hidden");
    }

    finishLoading() {
      this.removeAttribute("aria-disabled");
      this.classList.remove(this._marks.loading);
      this.elements.loadingSpinner?.classList.add("hidden");
    }
  }

  customElements.define("add-cart-button", AddCartButton);
}
